import { useRef } from 'react';
import { useSlideHighlight } from './useSlideHighlight';

// Shared glass-slider hover logic for a row list: the highlight box appears
// instantly on the first-ever hover (no transition), then slides smoothly
// between rows on subsequent hovers.
export const useRowHighlight = () => {
  const highlightRef = useRef(null);
  const hasHoveredRef = useRef(false);
  const { containerRef, boxStyle, handleMouseEnter, handleMouseLeave } = useSlideHighlight('y');

  const handleRowEnter = (e) => {
    if (!hasHoveredRef.current) {
      hasHoveredRef.current = true;
      const el = highlightRef.current;
      if (el) el.style.transition = 'none';
      handleMouseEnter(e);
      requestAnimationFrame(() => {
        if (el) el.style.transition = '';
      });
    } else {
      handleMouseEnter(e);
    }
  };

  return { containerRef, highlightRef, boxStyle, handleRowEnter, handleMouseLeave };
};
